export enum MensajesFijosEnum {
    ERROR_SERVIDOR = 'No se pudo completar la operación',
    ALERTA_REQUERIDO = 'Falta un campo requerido',
    OPERACION_EXITOSA = '',
    CONFIRMACION_OPERACION = '¿Está seguro que desea eliminar el registro?',
    SIN_PRODUCTOS_AGREGADOS = 'Es necesario agregar un producto a la compra',
    CAMBIAR_DOMICILIO = '¿Desea cambiar el domicilio para entrega?',
    CONFIRMAR_COMPRA_DOMICILIO = '¿Favor de seleccionar un domicilio antes de confirmar su compra?',
    BUSQUEDA_SIN_RESULTADOS = 'Sin resultados',
    ARBOL_SIN_HIJOS = 'Actualmente no tienes patrocinados o no estan activos.',
    AGREGAR_REFERENCIA_BANCARIA = 'Ingresa la Referencia bancaria del voucher',
    ERROR_FACTURAS_XML = "SU FACTURA NO SE PUDO GENERAR, CONTACTE AL ADMINISTRADOR",
    VALIDAR_CREDITOS = "No cuenta con los créditos disponibles para facturar",
    SIN_PROYECTOS_ACTIVOS = 'Lo sentimos, no encontramos proyectos activos!',
    SIN_ETAPAS_ACTIVAS = 'Lo sentimos, no encontramos etapas relacionadas al proyecto!',
    INCIDENCIA_EXITOSA = "Inserción exitosa",
    INCIDENCIA_ERROR = "Ocurrió un problema durante la inserción de la incidencia, intente más tarde",
    INCIDENCIA_DATOS_VACIOS = "No se permite dejar campos vacíos",
    INCIDENCIA_EVIDENCIAS_TAMANO = "Se excedió tamaño de MB permitidos",
    PROYECTOS_ASOCIADOS_ERROR = "¡No tiene proyectos asociados!",
    EXTENSION_EVIDENCIA = "El archivo no tiene la extensión adecuada, es necesario descargar",
    EVIDENCIA_NO_DISPONIBLE = "No fue posible obtener la evidencia, intente nuevamente más tarde",
}
